export enum UserPreference {
  none = 'None',
  boy = 'Boy',
  girl = 'Girl',
}
